export default __webpack_public_path__ + "static/media/tel-o2-logo-neg.a3d0d35c.png";